import Loader from "components/loader";
import VideoComponent from "components/videoComponent/videoComponent";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { renderError } from "utils/utils";
import * as yup from "yup";
import { addAppConfig, getAllVideos, getAppConfig } from "../../../axios/api";
import { toast } from "react-toastify";

const AppConfig = () => {
  const [loading, setLoading] = useState(false);
  const [videosData, setVideosData] = useState<any>([]);
  const [videosToShow, setVideosToShow] = useState<any>([]);
  const [homepageVideos, setHomepageVideos] = useState<any>([]);

  const fetchAppConfig = async () => {
    try {
      setLoading(true);
      const AppConfigDataResp = await getAppConfig();

      formik.setValues({
        totalVideos: Number(AppConfigDataResp?.data?.data[0].number_of_videos),
        videos_to_show: AppConfigDataResp?.data?.data[0].videos_to_show.length,
        homepage_videos:
          AppConfigDataResp?.data?.data[0].homepage_videos.length,
      });

      setVideosToShow(
        AppConfigDataResp?.data?.data[0].videos_to_show.map(String)
      );
      setHomepageVideos(
        AppConfigDataResp?.data?.data[0].homepage_videos.map(String)
      );
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAppConfig();
  }, []);

  useEffect(() => {
    const updatedHomePageVideos = homepageVideos.filter((item: any) =>
      videosToShow.includes(item)
    );
    setHomepageVideos(updatedHomePageVideos);
  }, [videosToShow]);

  const formik = useFormik({
    initialValues: {
      totalVideos: 0,
      videos_to_show: [],
      homepage_videos: [],
    },
    onSubmit: async (values) => {
      // console.log("values", values);
      try {
        setLoading(true);
        if (videosToShow?.length !== values.totalVideos) {
          // console.log(`please select ${values.totalVideos} videos`);
          toast.error(
            `please select ${values.totalVideos} videos in Videos to Show`
          );
          return;
        }
        if (homepageVideos?.length !== 2) {
          // console.log(`please select 2 Homepage videos`);
          toast.error(`please select 2 Homepage videos`);
          return;
        }
        const reqBody = {
          number_of_videos: values.totalVideos,
          videos_to_show: videosToShow,
          homepage_videos: homepageVideos,
        };
        const responseData = await addAppConfig(reqBody);
        // console.log("🚀 ~ onSubmit: ~ responseData:", responseData);
        if (responseData?.data?.success) {
          setVideosToShow([]);
          setHomepageVideos([]);
          toast.success("App Config Updated Successfully");
        } else {
          toast.error(
            "Something went wrong while updating App Config" + responseData
          );
          console.log("responseData", responseData);
        }
        await fetchAppConfig();
      } catch (error) {
        console.error("API Error:", error);
        toast.error("Something went wrong while updating App Config" + error);
      } finally {
        setLoading(false);
      }
    },
    validationSchema: yup.object({
      totalVideos: yup
        .number()
        .min(2, "At least 2 videos are required")
        .required("At least 2 videos are required"),
    }),
  });
  useEffect(() => {
    const fetchAllVideos = async () => {
      try {
        setLoading(true);
        const allVideoData = await getAllVideos(1, 9999);
        setVideosData(allVideoData?.data?.data?.videos);
      } catch (error) {
        console.log("error", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAllVideos();
  }, []);
  return (
    <div className="m-3 bg-[#FFFFFF] p-3">
      {loading ? (
        <Loader />
      ) : (
        <form onSubmit={formik.handleSubmit}>
          <div className="my-5 flex w-full flex-col">
            <div className="flex w-[60%] items-center justify-between gap-4">
              <div className="my-2 flex min-w-[50%] flex-col items-start justify-center gap-2">
                <label htmlFor="totalVideos" className="text-xl font-medium">
                  Number of Videos
                </label>
                <input
                  type="number"
                  name="totalVideos"
                  id="totalVideos"
                  value={formik.values.totalVideos}
                  onChange={formik.handleChange}
                  // defaultValue={10}
                  onBlur={formik.handleBlur}
                  placeholder="Enter No. of Video here"
                  className="h-10 w-[100%] rounded-md border-[2px] border-[#E4E6EF] bg-[transparent] p-2"
                />
                {formik.touched.totalVideos && formik.errors.totalVideos ? (
                  <div className="text-lg text-red-500">
                    {renderError(formik.errors.totalVideos)}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="m-2 flex items-center justify-between">
            <div className="text-xl font-medium text-[#424242]">
              Videos To Show
            </div>
            <div className="text-xl font-medium text-[#0E65A6]">
              ({videosToShow?.length} Videos Select)
            </div>
          </div>
          <div className="flex h-[30vh] overflow-y-auto">
            <div className="flex flex-wrap">
              {videosData &&
                videosData?.length > 0 &&
                videosData.map((videoData: any, index: any) => (
                  <div key={index} className="w-[14%] p-2">
                    <VideoComponent
                      videoData={videoData}
                      selectedVideos={videosToShow}
                      setSelectedVideos={setVideosToShow}
                      totalVideos={formik.values.totalVideos}
                    />
                  </div>
                ))}
            </div>
          </div>

          <div className="mx-2 mt-10 flex items-center justify-between">
            <div className="text-xl font-medium text-[#424242]">
              Homepage Videos
            </div>
            <div className="text-xl font-medium text-[#0E65A6]">
              ({homepageVideos?.length} Videos Select)
            </div>
          </div>
          <div className="flex h-[30vh] overflow-y-auto">
            <div className="flex flex-wrap">
              {videosData &&
                videosData?.length > 0 &&
                videosData.map(
                  (videoData: any, index: any) =>
                    videosToShow.includes(videoData.id) && (
                      <div key={index} className="w-[14%] p-2">
                        <VideoComponent
                          videoData={videoData}
                          selectedVideos={homepageVideos}
                          setSelectedVideos={setHomepageVideos}
                          totalVideos={2}
                        />
                      </div>
                    )
                )}
            </div>
          </div>
          <div>
            <button
              name="submit"
              className="float-right my-5 w-24 rounded bg-[#008BD2] p-2 text-xl font-bold text-white"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AppConfig;
